export const DownloadIcon = () => {
    return (
        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2458_5221)">
                <path
                    d="M2.25 11.0834H12.75V12.2501H2.25V11.0834ZM8.08333 7.68378L11.6247 4.14178L12.4496 4.96661L7.5 9.91678L2.55042 4.9672L3.37525 4.14178L6.91667 7.68261V1.16678H8.08333V7.68378Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_2458_5221">
                    <rect width="14" height="14" fill="currentColor" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};
